import { defineComponent as e, openBlock as a, createElementBlock as i, normalizeClass as n, normalizeStyle as o } from "vue";
import { _ as s } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
import './assets/BaseIcon.css';const r = e({
  name: "BaseIcon",
  props: {
    lazyLoading: { type: Boolean, default: !1 },
    altAttribute: {
      type: String,
      default: ""
    },
    iconName: {
      type: String,
      default: ""
    },
    iconType: {
      type: String,
      default: "icon-md"
    },
    iconClass: {
      type: String,
      default: "uikit-mr-5px"
    }
  }
}), l = ["id", "alt", "src", "width", "height", "loading"];
function d(t, p, c, f, m, u) {
  return a(), i("img", {
    id: t.$attrs.id,
    class: n(["uikit-inline-block", t.iconType, t.iconClass]),
    alt: t.altAttribute || t.$attrs.alt,
    style: o(t.$attrs.style),
    src: t.$attrs.src ? t.$attrs.src : "",
    width: t.$attrs.width,
    height: t.$attrs.height,
    loading: t.lazyLoading ? "lazy" : "eager"
  }, null, 14, l);
}
const h = /* @__PURE__ */ s(r, [["render", d], ["__scopeId", "data-v-8b2e5b08"]]);
export {
  h as default
};
